export default "__VITE_ASSET__NrK85RUS__"